// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18":"88db83ca5306c87e33a1","346":"11bd45e876048821eae6","467":"037885932d6ed71c409d","551":"c36dd2f4cbd42b0a7475","645":"1cdbfb42ea1128bade15","848":"448c2eeb278c50f0904f","941":"417c2f25bd0c6c4e0fce","956":"57f264d41539d804f78e"}[chunkId] + ".bundle.js";
};